import React, { useCallback, useMemo, useState } from 'react';
import styles from './NewFooter.module.scss';
import AdminLoginModal from './AdminLoginModal';
import { Dropdown } from 'Components';
import { Menu } from 'antd';
import {
	HELP_DESK_LINK,
	PRIVACY_POLICY_LINK,
	TERMS_OF_USE_LINK
} from 'app-config';

interface FooterProps {
	isAdminLogin: boolean;
	setShowResetPassword?: React.Dispatch<React.SetStateAction<boolean>>;
}

const NewFooter: React.FC<FooterProps> = ({
	isAdminLogin,
	setShowResetPassword
}) => {
	const [showModal, setShowModal] = useState(false);

	const openUrl = useCallback(
		(url: string) => window.open(url, '_blank'),
		[]
	);
	const toggleModal = useCallback((show: boolean) => setShowModal(show), []);

	const contents = useMemo(
		() => [
			{ label: 'Contact', onclick: () => openUrl(HELP_DESK_LINK) },
			{
				label: 'Terms of Use',
				onclick: () => openUrl(TERMS_OF_USE_LINK)
			},
			{ label: 'Privacy', onclick: () => openUrl(PRIVACY_POLICY_LINK) },
			...(isAdminLogin
				? [
						{
							label: 'Venza Admin',
							onclick: () => toggleModal(true)
						}
				  ]
				: [])
		],
		[isAdminLogin]
	);

	return (
		<>
			<div className={styles.root}>
				{contents.map((el, index) => (
					<FooterItem
						key={index}
						label={el.label}
						onclick={el.onclick}
					/>
				))}
				<LanguageDropDown />
			</div>
			{setShowResetPassword && (
				<AdminLoginModal
					visible={showModal}
					onCancel={() => toggleModal(false)}
					setShowResetPassword={setShowResetPassword}
				/>
			)}
		</>
	);
};

const LanguageDropDown = () => {
	const menu = (
		<Menu style={{ borderRadius: '6px' }}>
			<Menu.Item>English</Menu.Item>
			<Menu.Item disabled>Spanish</Menu.Item>
			<Menu.Item disabled>French</Menu.Item>
			<Menu.Item disabled>German</Menu.Item>
		</Menu>
	);

	return (
		<Dropdown overlay={menu} className={styles.languageBtn}>
			English
		</Dropdown>
	);
};

interface FooterItemProps {
	label: string;
	onclick: () => void;
}

const FooterItem: React.FC<FooterItemProps> = ({ label, onclick }) => {
	return (
		<div className={styles.label} onClick={onclick}>
			{label}
		</div>
	);
};

export default NewFooter;
